<template>
  <b-dropdown
    :no-caret="showIcon"
    :disabled="disabled"
    boundary="scrollParent"
    class="collapse-dropdown"
    variant="link"
  >
    <template slot="button-content">
      <i
        v-if="showIcon"
        aria-hidden="true"
        class="fas fa-ellipsis-v text-gray"
      />
      <span
        v-if="!showIcon"
      >
        {{ selectedExpandRetract }}
      </span>
    </template>
    <b-dropdown-item @click="fireClickEvent(true)">
      {{ $t('actions.expand-all') }}
    </b-dropdown-item>
    <b-dropdown-item @click="fireClickEvent(false)">
      {{ $t('actions.retract-all') }}
    </b-dropdown-item>
  </b-dropdown>
</template>
<style lang="sass" scoped>
  .collapse-dropdown
    color: var(--font-color-primary)
</style>

<script>
/**
 * Dropdown com opções estáticas de expandir/recolher usadas nas abas dos Sensores.
 * @event click-option Evento de clique em opção do drop-down. Recebe um Boolean por parametro
 * que indica se deve expandir (true) ou colapsar (false).
 */
export default {
  props: {
    initializeExpanded: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedExpandRetract: '',
  }),
  created() {
    this.checkTextExpandRetract(this.initializeExpanded);
  },
  methods: {
    fireClickEvent(toExpand) {
      this.checkTextExpandRetract(toExpand);
      this.$emit('click-option', toExpand);
    },
    checkTextExpandRetract(toExpand) {
      if (toExpand) {
        this.selectedExpandRetract = this.$t('actions.retract-all');
        return;
      }
      this.selectedExpandRetract = this.$t('actions.expand-all');
    },
  },
};
</script>
